import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import { css } from '@emotion/core';

import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';

// @ts-ignore
import Image from '../content/img/git-commits.png';
// @ts-ignore
import ImageTwo from '../content/img/git-commits2.png';
// @ts-ignore
import ImageThree from '../content/img/git-commits3.png';

const PageTemplate = css`
  .site-main {
    background: #fff;
    padding-bottom: 4vw;

    img {
      width: 100%;
    }
  }
`;

const Git: React.FunctionComponent = () => (
  <IndexLayout>
    <Helmet>
      <title>Developer's Quickstart</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header css={[outer, SiteHeader]}>
        <div css={inner}>
          <SiteNav />
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <article className="post page" css={[PostFull, NoImage]}>
          <PostFullHeader>
            <PostFullTitle>Developer's Quickstart</PostFullTitle>
          </PostFullHeader>

          <PostFullContent className="post-full-content">
            <div className="post-content">
              <p>
                Niniejsza strona stanowi spis najważniejszych procesów i ich opisów, a także poradników, które każdy developer w Studio Sidekicks powinien sobie przyswoić przed rozpoczęciem pracy.
              </p>
              <ul>
                <li><a href="/kultura-organizacji">Kultura organizacji</a></li>
                <li><a href="/git">Zasady dotyczące korzystania z Gita</a></li>
                <li><a href="/srodowisko-developera">Środowiska pracy (local, staging, produkcja)</a><br /> <small>Niniejsza strona zawiera kluczowe informacje względem lokalnego środowiska developera (co należy mieć zainstalowane), jak wygląda staging (jak tworzyć instancje, jak zmieniać branch itd.) oraz produkcja (z dokładnym opisem, jak samodzielnie stworzyć typowe produkcyjne środowisko).</small></li>
                <li><a href="/dev-proces">Jak wygląda proces developmentu</a></li>
                <li><a href="/dev-proces">Proces pójścia "live" na produkcję</a></li>
                <li><strong>Dla front-end developerów:</strong> <a href="/proces-tworzenia-front-endu">Proces tworzenia frontendu</a></li>
                <li><a href="https://docs.alfred-cms.com" target="_blank" rel="noopener noreferrer">Dokumentacja Alfred CMS</a></li>
              </ul>
            </div>
          </PostFullContent>
        </article>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default Git;
